<div class="fieldset" [formGroup]="form">

    <legend>Question Visibility Rule</legend>

    <div class="message">
        You can set a visibility rule to show '{{ $question()?.name }}' only when a certain condition is met.
    </div>

    <div class="field">
        <label>Show When</label>

        <div class="value">
            <ng-select formControlName="question" bindLabel="name" bindValue="_id" appendTo="body" [clearable]="false" [items]="$conditionQuestions()"></ng-select>
        </div>
    </div>

    <div class="field" *ngIf="$hasRule()">
        <label>Equals</label>

        <div class="value">
            <ng-select formControlName="value" bindLabel="name" bindValue="_id" appendTo="body" [clearable]="false" [items]="$options()"></ng-select>
        </div>
    </div>

</div>

<div class="actions">
    <button class="btn btn-none" (click)="cancel()">Cancel</button>
    <button class="btn btn-primary" (click)="save()" [disabled]="form.pristine || form.invalid">Save</button>
</div>
